export {isFlutterAppWebView} from '../_web/utils/flutter/isFlutterAppWebView'
export * from './extractMobileAppVerison'
export {isMobileApp} from './isMobileApp'
export {isMobileAppUserAgent} from './isMobileAppUserAgent'
export {isReactNativeWebView} from './isReactNativeWebView'
export {postMessageToWebView} from './postMessageToWebView'
export {
  MessageListenerTypes,
  NotificationStatusTypes,
  RNWebViewMessageTypes
} from './types'
